import React from 'react';
import PropTypes from 'prop-types';
import SrBox from 'client/components/SrBox';

import './UPLoadingConfirmationSpinner.less';
import classNames from 'classnames';

const UPLoadingConfirmationSpinner = ({
  successText,
  successIconUrl,
  loadingText,
  loadingIconUrl,
  success,
}) => {
  const text = success ? successText : loadingText;
  const iconUrl = success ? successIconUrl : loadingIconUrl;

  return (
    <div styleName="UPLoadingConfirmationSpinner">
      <SrBox styleName={classNames('icon', { success })} backgroundImage={`url(${iconUrl})`} />
      <div styleName="textContainer">
        <span styleName="text">{text}</span>
      </div>
    </div>
  );
};

UPLoadingConfirmationSpinner.propTypes = {
  successText: PropTypes.string.isRequired,
  successIconUrl: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired,
  success: PropTypes.bool.isRequired,
  loadingIconUrl: PropTypes.string.isRequired,
};

export default UPLoadingConfirmationSpinner;
